import floralDark from './floral-swatch-dark.png'
import floralLight from './floral-swatch-light.png'

export const justValues = obj => Object.values(obj)

export const levels = {
  beginner: 'New to makeup',
  intermediate: 'Know the basics',
  advanced: 'Makeup obsessed',
}

export const skinConcerns = {
  ageing: 'Ageing skin',
  dry: 'Dry skin',
  oily: 'Acne / oily skin',
  sensitive: 'Sensitive skin',
  combination: 'Combination skin',
}

export const colours = [
  {label: 'White', swatch: {colour: '#fff'}},
  {label: 'Yellow', swatch: {colour: '#fbef6a'}},
  {label: 'Grey', swatch: {colour: '#b6b4b4'}},
  {label: 'Beige', swatch: {colour: '#ad9b7f'}},
  {label: 'Black', swatch: {colour: '#434242'}},
  {label: 'Brown', swatch: {colour: '#68440d'}},
  {label: 'Red', swatch: {colour: '#b50b0b'}},
  {label: 'Purple', swatch: {colour: '#781cc8'}},
  {label: 'Blue', swatch: {colour: '#3272b1'}},
  {label: 'Green', swatch: {colour: '#2b7126'}},
  {label: 'Pink', swatch: {colour: '#f49cd5'}},
  {label: 'Orange', swatch: {colour: '#fb9f1e'}},
  {label: 'Floral', swatch: {img: floralDark, alt: 'Floral dark'}},
  {label: 'Floral', swatch: {img: floralLight, alt: 'Floral light'}},
]

export const timesOfDay = {
  day: 'Day',
  afternoon: 'Afternoon',
  night: 'Night',
}

export const occasions = {
  cocktail: 'Cocktail',
  wedding: 'Wedding',
  work: 'Work',
  workEvent: 'Work event',
  date: 'Date',
}

export const vibes = {
  effortless: 'Effortless',
  sophisticated: 'Sophisticated',
  glam: 'Glam',
  sexy: 'Sexy',
  casual: 'Natural / casual',
}

export const weatherConditions = {
  hotHumid: 'Hot / humid',
  cold: 'Winter',
  hotDry: 'Dry heat',
  mild: 'Mild / pleasant',
}

export const dailyMakeup = {
  minimal: 'Prefer a minimal amount',
  basic: 'Basic but open to new looks',
  full: 'I feel naked without a full face',
  minimalPlus: 'Minimal – but have occasions to step up',
}
